import React from 'react';
import styled from 'styled-components';

const Container = styled.div``;

const Body: React.FunctionComponent = ({ children, ...rest }) => {
  return <Container {...rest}>{children}</Container>;
};
export default Body;
